var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { formatShortDate, formatShortDateAndTime, formatShortTime, normalizedDate, } from "./helpers";
import "./styles.scss";
import BEM from "../bem";
import html from "../htmlTemplateTag";
var widgetBem = BEM("upcoming-events-widget");
var eventBem = BEM("upcoming-event");
var createWidgets = function () {
    "use strict";
    /**
     * The API endpoint for retrieving upcoming events.
     */
    var ENDPOINT = "https://scs-app-backend-481f8.web.app/api/v1/events10";
    var widgetContainers = widgetBem.select();
    var fetchEvents = function () {
        var e_1, _a;
        var now = new Date();
        var today = normalizedDate(now);
        widgetBem.modify({ state: "loading" });
        try {
            for (var widgetContainers_1 = __values(widgetContainers), widgetContainers_1_1 = widgetContainers_1.next(); !widgetContainers_1_1.done; widgetContainers_1_1 = widgetContainers_1.next()) {
                var widget = widgetContainers_1_1.value;
                widget.innerHTML = html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<div class=\"", "\">\n        Loading...\n      </div>"], ["<div class=\"", "\">\n        Loading...\n      </div>"])), widgetBem("loading"));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (widgetContainers_1_1 && !widgetContainers_1_1.done && (_a = widgetContainers_1.return)) _a.call(widgetContainers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        fetch(ENDPOINT)
            .then(function (response) { return response.json(); })
            .then(function (response) {
            var events = "events" in response && response.events ? response.events : [];
            return events.map(function (event) {
                var _a, _b, _c, _d, _e, _f;
                var daysDiff;
                var timeString;
                var allDayEvent = typeof ((_a = event.start) === null || _a === void 0 ? void 0 : _a.date) === "string" &&
                    typeof ((_b = event.end) === null || _b === void 0 ? void 0 : _b.date) === "string";
                if (allDayEvent) {
                    var _g = __read((((_c = event.start) === null || _c === void 0 ? void 0 : _c.date) || "").split("-"), 3), startYear = _g[0], startMonth = _g[1], startDate = _g[2];
                    var _h = __read((((_d = event.end) === null || _d === void 0 ? void 0 : _d.date) || "").split("-"), 3), endYear = _h[0], endMonth = _h[1], endDate = _h[2];
                    var eventStartDate = normalizedDate(new Date(+startYear, +startMonth - 1, +startDate));
                    var eventEndDate = normalizedDate(new Date(+endYear, +endMonth - 1, +endDate - 1));
                    daysDiff = Math.round((eventStartDate.valueOf() - today.valueOf()) /
                        (1000 * 60 * 60 * 24));
                    // Check if this event spans multiple days.
                    if (eventStartDate.valueOf() !== eventEndDate.valueOf()) {
                        // Check if this event spans into another month.
                        if (eventStartDate.getMonth() !== eventEndDate.getMonth()) {
                            timeString = "".concat(formatShortDate(eventStartDate), " to ").concat(formatShortDate(eventEndDate), ", all-day");
                        }
                        else {
                            timeString = "".concat(formatShortDate(eventStartDate), "\u2013").concat(eventEndDate.getDate(), ", all-day");
                        }
                    }
                    else {
                        timeString = "".concat(formatShortDate(eventStartDate), ", all-day");
                    }
                }
                else {
                    var eventStartDateTime = new Date(((_e = event.start) === null || _e === void 0 ? void 0 : _e.dateTime) || new Date());
                    var eventStartDate = normalizedDate(eventStartDateTime);
                    var eventEndDateTime = new Date(((_f = event.end) === null || _f === void 0 ? void 0 : _f.dateTime) || new Date());
                    var eventEndDate = normalizedDate(eventEndDateTime);
                    daysDiff = Math.round((eventStartDate.valueOf() - today.valueOf()) /
                        (1000 * 60 * 60 * 24));
                    // Check if this event spans multiple days.
                    if (eventStartDate.valueOf() !== eventEndDate.valueOf()) {
                        timeString = "".concat(formatShortDate(eventStartDateTime), " to ").concat(formatShortDateAndTime(eventEndDateTime));
                    }
                    else {
                        timeString = "".concat(formatShortDate(eventStartDate), " from ").concat(formatShortTime(eventStartDateTime, eventStartDateTime.getHours() < 12 !==
                            eventEndDateTime.getHours() < 12), "\u2013").concat(formatShortTime(eventEndDateTime, true));
                    }
                }
                return {
                    name: event.summary,
                    time: timeString,
                    location: event.location,
                    subject: event.description,
                    daysToEvent: daysDiff <= 0
                        ? "Today"
                        : daysDiff === 1
                            ? "Tomorrow"
                            : "In ".concat(daysDiff, " days"),
                    link: event.htmlLink,
                };
            });
        })
            .then(function (events) {
            return events.map(function (event) {
                var div = document.createElement("div");
                div.classList.add(eventBem.className);
                div.innerHTML = html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            <div class=\"", "\">\n              <h3 class=\"", "\">", "</h3>\n              <div class=\"", "\">\n                ", "\n              </div>\n              <div class=\"", "\">\n                ", "\n              </div>\n            </div>\n            <div class=\"", "\">\n              <div class=\"", "\">\n                ", "\n              </div>\n            </div>\n            <div class=\"", "\">\n              <div class=\"", "\">\n                ", "\n              </div>\n              <a\n                href=\"", "\"\n                target=\"_blank\"\n                rel=\"external noreferrer\"\n                class=\"", " fa-regular fa-calendar\"\n              ></a>\n            </div>\n          "], ["\n            <div class=\"", "\">\n              <h3 class=\"", "\">", "</h3>\n              <div class=\"", "\">\n                ", "\n              </div>\n              <div class=\"", "\">\n                ", "\n              </div>\n            </div>\n            <div class=\"", "\">\n              <div class=\"", "\">\n                ", "\n              </div>\n            </div>\n            <div class=\"", "\">\n              <div class=\"", "\">\n                ", "\n              </div>\n              <a\n                href=\"", "\"\n                target=\"_blank\"\n                rel=\"external noreferrer\"\n                class=\"", " fa-regular fa-calendar\"\n              ></a>\n            </div>\n          "])), eventBem("info-text"), eventBem("info-text-name"), event.name, eventBem("info-text-time"), event.time || "", eventBem("info-text-location"), event.location || "", eventBem("subject"), eventBem("subject-text"), event.subject || "", eventBem("calendar"), eventBem("calendar-text"), event.daysToEvent || "", event.link, eventBem("calendar-icon"));
                return div;
            });
        })
            .then(function (eventElements) {
            var e_2, _a;
            var isEmpty = eventElements.length === 0;
            if (isEmpty) {
                var div = document.createElement("div");
                div.classList.add("".concat(widgetBem("no-events")));
                div.innerText = "No upcoming events. Check back later for more!";
                eventElements.push(div);
            }
            var elementClones = Array.from({
                length: widgetContainers.length,
            });
            elementClones[0] = eventElements;
            for (var i = 1; i < widgetContainers.length; i++) {
                elementClones[i] = Array.from({ length: eventElements.length });
                for (var j = 0; j < eventElements.length; j++) {
                    elementClones[i][j] = eventElements[j].cloneNode(true);
                }
            }
            // Add a class indicating whether the widget has events or not.
            widgetBem.modify({ empty: isEmpty, filled: !isEmpty });
            for (var i = 0; i < widgetContainers.length; i++) {
                // Clear the widget container's children.
                widgetContainers[i].textContent = "";
                try {
                    // Insert each event one-by-one.
                    for (var _b = (e_2 = void 0, __values(elementClones[i])), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var element = _c.value;
                        widgetContainers[i].appendChild(element);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        })
            .catch(function () {
            var div = document.createElement("div");
            div.classList.add(widgetBem("errored").className);
            div.innerHTML = html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          <div>There was a problem getting the events.</div>\n          <button\n            class=\"", "\"\n          >\n            Try again\n          </button>\n        "], ["\n          <div>There was a problem getting the events.</div>\n          <button\n            class=\"", "\"\n          >\n            Try again\n          </button>\n        "])), BEM.button({
                bg: "primary",
                text: "lightest",
                hover: "shadow",
            }));
            widgetBem.modify({ state: "errored" });
            for (var i = 0; i < widgetContainers.length; i++) {
                // Clear the widget container's children.
                widgetContainers[i].textContent = "";
                var clone = div.cloneNode(true);
                var button = clone.querySelector("button");
                button.addEventListener("click", fetchEvents);
                widgetContainers[i].appendChild(clone);
            }
        });
    };
    fetchEvents();
};
export default createWidgets;
var templateObject_1, templateObject_2, templateObject_3;
